import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/Card';
import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';
import { Badge } from '../../../components/ui/Badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/Select';
import { 
  CreditCard, 
  Plus, 
  Edit, 
  Trash2, 
  Play, 
  Pause, 
  BarChart3,
  Filter,
  Search,
  ArrowUp,
  ArrowDown,
  Target,
  Clock,
  AlertTriangle,
  CheckCircle,
  DollarSign,
  RefreshCw,
  Download,
  Upload,
  Settings,
  Zap,
  RotateCcw,
  Eye,
  EyeOff,
  Copy,
  ExternalLink,
  TrendingUp,
  TrendingDown,
  Star,
  Crown,
  Shield,
  Activity,
  UserCheck,
  Timer,
  Brain,
  Route,
  Lightning,
  Cpu,
  Database,
  Network,
  Monitor,
  UserPlus,
  UserMinus,
  Calendar,
  Mail,
  Phone,
  MessageSquare,
  Send,
  Archive,
  Unarchive,
  History,
  AlertCircle,
  Info,
  HelpCircle,
  XCircle,
  CheckCircle2,
  Clock3,
  CalendarDays,
  UserX,
  UserCog,
  UserSearch,
  UserEdit,
  Globe,
  Link,
  Key,
  Lock,
  Unlock,
  TestTube,
  Bug,
  Wifi,
  WifiOff,
  Server,
  Cloud,
  CloudOff,
  Terminal,
  Code,
  Hash,
  Layers,
  Box,
  Package,
  Archive as ArchiveIcon,
  File,
  Folder,
  FolderOpen,
  FileCode,
  FileJson,
  FileText as FileTextIcon,
  FileImage,
  FileVideo,
  FileAudio,
  FileSpreadsheet,
  FilePdf,
  FileZip,
  FileCheck,
  FileX,
  FilePlus,
  FileMinus,
  FileEdit,
  FileSearch,
  FileSlash,
  FileWarning,
  FileQuestion,
  FileHeart,
  FileClock,
  FileUp,
  FileDown,
  FileLeft,
  FileRight,
  FileBarChart,
  FilePieChart,
  FileLineChart,
  FileScissors,
  FileType,
  FileSymlink,
  FileStack,
  FileTree,
  FileBinary,
  FileCog,
  FileSettings,
  FileShield,
  FileLock,
  FileUnlock,
  FileKey,
  FileCertificate,
  FileSignature,
  FileVerified,
  FileBadge,
  FileTag,
  FileLabel,
  FileBookmark,
  FileStar,
  FileFlag,
  FileAlert,
  FileInfo,
  FileHelp,
  FileMessage,
  FileComment,
  FileChat,
  FileMail,
  FilePhone,
  FileVideo as FileVideoIcon,
  FileAudio as FileAudioIcon,
  FileImage as FileImageIcon,
  FileSpreadsheet as FileSpreadsheetIcon,
  FilePdf as FilePdfIcon,
  FileZip as FileZipIcon,
  FileCheck as FileCheckIcon,
  FileX as FileXIcon,
  FilePlus as FilePlusIcon,
  FileMinus as FileMinusIcon,
  FileEdit as FileEditIcon,
  FileSearch as FileSearchIcon,
  FileSlash as FileSlashIcon,
  FileWarning as FileWarningIcon,
  FileQuestion as FileQuestionIcon,
  FileHeart as FileHeartIcon,
  FileClock as FileClockIcon,
  FileUp as FileUpIcon,
  FileDown as FileDownIcon,
  FileLeft as FileLeftIcon,
  FileRight as FileRightIcon,
  FileBarChart as FileBarChartIcon,
  FilePieChart as FilePieChartIcon,
  FileLineChart as FileLineChartIcon,
  FileScissors as FileScissorsIcon,
  FileType as FileTypeIcon,
  FileSymlink as FileSymlinkIcon,
  FileStack as FileStackIcon,
  FileTree as FileTreeIcon,
  FileBinary as FileBinaryIcon,
  FileCog as FileCogIcon,
  FileSettings as FileSettingsIcon,
  FileShield as FileShieldIcon,
  FileLock as FileLockIcon,
  FileUnlock as FileUnlockIcon,
  FileKey as FileKeyIcon,
  FileCertificate as FileCertificateIcon,
  FileSignature as FileSignatureIcon,
  FileVerified as FileVerifiedIcon,
  FileBadge as FileBadgeIcon,
  FileTag as FileTagIcon,
  FileLabel as FileLabelIcon,
  FileBookmark as FileBookmarkIcon,
  FileStar as FileStarIcon,
  FileFlag as FileFlagIcon,
  FileAlert as FileAlertIcon,
  FileInfo as FileInfoIcon,
  FileHelp as FileHelpIcon,
  FileMessage as FileMessageIcon,
  FileComment as FileCommentIcon,
  FileChat as FileChatIcon,
  FileMail as FileMailIcon,
  FilePhone as FilePhoneIcon
} from 'lucide-react';
import { useDataContext } from '../../../contexts/DataContext';

const PaymentProcessing = () => {
  const { getMockData, updateMockData } = useDataContext();
  const [payments, setPayments] = useState([]);
  const [gateways, setGateways] = useState([]);
  const [refunds, setRefunds] = useState([]);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [editingPayment, setEditingPayment] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterGateway, setFilterGateway] = useState('all');

  useEffect(() => {
    loadPaymentData();
  }, []);

  const loadPaymentData = async () => {
    try {
      const data = getMockData('payments');
      const gatewaysData = getMockData('paymentGateways');
      const refundsData = getMockData('refunds');
      
      setPayments(data?.payments || []);
      setGateways(gatewaysData?.gateways || []);
      setRefunds(refundsData?.refunds || []);
    } catch (error) {
      console.error('Failed to load payment data:', error);
    }
  };

  const handleProcessPayment = () => {
    setIsProcessingPayment(true);
  };

  const handleEditPayment = (payment) => {
    setEditingPayment(payment);
  };

  const handleRetryPayment = (paymentId) => {
    if (window.confirm('Are you sure you want to retry this payment?')) {
      alert(`Retrying payment ${paymentId}...`);
    }
  };

  const handleRefundPayment = (paymentId) => {
    if (window.confirm('Are you sure you want to refund this payment?')) {
      alert(`Processing refund for payment ${paymentId}...`);
    }
  };

  const handleChargebackPayment = (paymentId) => {
    if (window.confirm('Are you sure you want to process chargeback for this payment?')) {
      alert(`Processing chargeback for payment ${paymentId}...`);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed': return 'green';
      case 'pending': return 'yellow';
      case 'failed': return 'red';
      case 'refunded': return 'blue';
      case 'chargeback': return 'red';
      default: return 'gray';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed': return CheckCircle;
      case 'pending': return Clock;
      case 'failed': return AlertTriangle;
      case 'refunded': return RotateCcw;
      case 'chargeback': return AlertCircle;
      default: return AlertTriangle;
    }
  };

  const filteredPayments = payments.filter(payment => {
    const matchesSearch = payment.customerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         payment.transactionId.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         payment.gateway.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === 'all' || payment.status === filterStatus;
    const matchesGateway = filterGateway === 'all' || payment.gateway === filterGateway;
    return matchesSearch && matchesStatus && matchesGateway;
  });

  const mockPayments = [
    {
      id: 1,
      transactionId: "TXN-2025-001",
      customerName: "Acme Corporation",
      customerEmail: "billing@acme.com",
      amount: 999.00,
      currency: "USD",
      gateway: "Stripe",
      status: "completed",
      paymentMethod: "Credit Card ending in 1234",
      processedAt: "2025-01-15T14:30:00Z",
      createdAt: "2025-01-15T14:25:00Z",
      description: "Enterprise Plan - Annual Subscription",
      fees: 29.97,
      netAmount: 969.03
    },
    {
      id: 2,
      transactionId: "TXN-2025-002",
      customerName: "TechStart Inc",
      customerEmail: "admin@techstart.com",
      amount: 299.00,
      currency: "USD",
      gateway: "PayPal",
      status: "pending",
      paymentMethod: "PayPal Account",
      processedAt: null,
      createdAt: "2025-01-15T16:45:00Z",
      description: "Professional Plan - Monthly Subscription",
      fees: 8.97,
      netAmount: 290.03
    },
    {
      id: 3,
      transactionId: "TXN-2025-003",
      customerName: "SmallBiz Solutions",
      customerEmail: "owner@smallbiz.com",
      amount: 99.00,
      currency: "USD",
      gateway: "Stripe",
      status: "failed",
      paymentMethod: "Credit Card ending in 5678",
      processedAt: null,
      createdAt: "2025-01-15T17:20:00Z",
      description: "Basic Plan - Monthly Subscription",
      fees: 0,
      netAmount: 0,
      failureReason: "Insufficient funds"
    },
    {
      id: 4,
      transactionId: "TXN-2025-004",
      customerName: "Global Enterprises",
      customerEmail: "it@globalent.com",
      amount: 1999.00,
      currency: "USD",
      gateway: "Stripe",
      status: "refunded",
      paymentMethod: "Credit Card ending in 9012",
      processedAt: "2025-01-14T10:15:00Z",
      createdAt: "2025-01-14T10:00:00Z",
      description: "Enterprise Plan - Annual Subscription",
      fees: 59.97,
      netAmount: 1939.03,
      refundedAt: "2025-01-15T09:30:00Z",
      refundAmount: 1999.00
    },
    {
      id: 5,
      transactionId: "TXN-2025-005",
      customerName: "StartupCo",
      customerEmail: "founder@startupco.com",
      amount: 149.00,
      currency: "USD",
      gateway: "PayPal",
      status: "chargeback",
      paymentMethod: "PayPal Account",
      processedAt: "2025-01-13T15:45:00Z",
      createdAt: "2025-01-13T15:40:00Z",
      description: "Professional Plan - Monthly Subscription",
      fees: 4.47,
      netAmount: 144.53,
      chargebackAt: "2025-01-15T11:20:00Z",
      chargebackAmount: 149.00
    }
  ];

  const paymentMetrics = [
    {
      title: 'Total Payments Today',
      value: payments.length,
      icon: CreditCard,
      color: 'blue',
      trend: '+12',
      trendDirection: 'up'
    },
    {
      title: 'Successful Payments',
      value: payments.filter(p => p.status === 'completed').length,
      icon: CheckCircle,
      color: 'green',
      trend: '+8',
      trendDirection: 'up'
    },
    {
      title: 'Total Revenue',
      value: '$1,545.00',
      icon: DollarSign,
      color: 'green',
      trend: '+15.2%',
      trendDirection: 'up'
    },
    {
      title: 'Failed Payments',
      value: payments.filter(p => p.status === 'failed').length,
      icon: AlertTriangle,
      color: 'red',
      trend: '-2',
      trendDirection: 'down'
    }
  ];

  return (
    <div className="payment-processing p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="mb-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Payment Processing</h1>
            <p className="text-gray-600">Process payments and handle payment issues</p>
          </div>
          <div className="flex items-center space-x-4">
            <Button onClick={handleProcessPayment}>
              <Plus className="h-4 w-4 mr-2" />
              Process Payment
            </Button>
            <Button variant="outline">
              <BarChart3 className="h-4 w-4 mr-2" />
              Analytics
            </Button>
          </div>
        </div>
      </div>

      {/* Metrics Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {paymentMetrics.map((metric, index) => {
          const Icon = metric.icon;
          return (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium text-gray-600">{metric.title}</CardTitle>
                <Icon className={`h-4 w-4 text-${metric.color}-500`} />
              </CardHeader>
              <CardContent>
                <div className="text-2xl font-bold text-gray-900">{metric.value}</div>
                <div className={`flex items-center text-xs ${
                  metric.trendDirection === 'up' ? 'text-green-600' : 'text-red-600'
                }`}>
                  <ArrowUp className="h-3 w-3 mr-1" />
                  {metric.trend} from yesterday
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Filters and Search */}
      <Card className="mb-8">
        <CardHeader>
          <CardTitle className="flex items-center">
            <Filter className="h-5 w-5 mr-2" />
            Filter Payments
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center space-x-4">
            <div className="flex-1">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                <Input
                  placeholder="Search payments..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-10"
                />
              </div>
            </div>
            <Select value={filterStatus} onValueChange={setFilterStatus}>
              <SelectTrigger className="w-48">
                <SelectValue placeholder="Filter by status" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Status</SelectItem>
                <SelectItem value="completed">Completed</SelectItem>
                <SelectItem value="pending">Pending</SelectItem>
                <SelectItem value="failed">Failed</SelectItem>
                <SelectItem value="refunded">Refunded</SelectItem>
                <SelectItem value="chargeback">Chargeback</SelectItem>
              </SelectContent>
            </Select>
            <Select value={filterGateway} onValueChange={setFilterGateway}>
              <SelectTrigger className="w-48">
                <SelectValue placeholder="Filter by gateway" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Gateways</SelectItem>
                <SelectItem value="Stripe">Stripe</SelectItem>
                <SelectItem value="PayPal">PayPal</SelectItem>
                <SelectItem value="Square">Square</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </CardContent>
      </Card>

      {/* Payments List */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <CreditCard className="h-5 w-5 mr-2" />
            Payment Transactions ({mockPayments.length})
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {mockPayments.map((payment) => {
              const StatusIcon = getStatusIcon(payment.status);
              return (
                <div key={payment.id} className="p-6 border rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex-1">
                      <div className="flex items-center space-x-3 mb-2">
                        <h3 className="text-lg font-semibold">{payment.transactionId}</h3>
                        <Badge variant={payment.status === 'completed' ? 'default' : 'secondary'}>
                          <StatusIcon className="h-3 w-3 mr-1" />
                          {payment.status}
                        </Badge>
                        <Badge variant="outline">{payment.gateway}</Badge>
                      </div>
                      <p className="text-gray-600 mb-3">
                        <strong>{payment.customerName}</strong> - {payment.customerEmail}
                      </p>
                      
                      {/* Payment Details */}
                      <div className="mb-3">
                        <h4 className="text-sm font-medium text-gray-700 mb-2">Payment Details:</h4>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm text-gray-600">
                          <div>
                            <span className="font-medium">Amount:</span> ${payment.amount} {payment.currency}
                          </div>
                          <div>
                            <span className="font-medium">Fees:</span> ${payment.fees}
                          </div>
                          <div>
                            <span className="font-medium">Net Amount:</span> ${payment.netAmount}
                          </div>
                          <div>
                            <span className="font-medium">Method:</span> {payment.paymentMethod}
                          </div>
                        </div>
                      </div>

                      {/* Description */}
                      <div className="mb-3">
                        <h4 className="text-sm font-medium text-gray-700 mb-2">Description:</h4>
                        <p className="text-sm text-gray-600">{payment.description}</p>
                      </div>

                      {/* Timestamps */}
                      <div className="flex items-center space-x-6 text-sm text-gray-600">
                        <div className="flex items-center">
                          <Calendar className="h-4 w-4 mr-1" />
                          <span>Created: {new Date(payment.createdAt).toLocaleString()}</span>
                        </div>
                        {payment.processedAt && (
                          <div className="flex items-center">
                            <Clock className="h-4 w-4 mr-1" />
                            <span>Processed: {new Date(payment.processedAt).toLocaleString()}</span>
                          </div>
                        )}
                        {payment.refundedAt && (
                          <div className="flex items-center">
                            <RotateCcw className="h-4 w-4 mr-1" />
                            <span>Refunded: {new Date(payment.refundedAt).toLocaleString()}</span>
                          </div>
                        )}
                        {payment.chargebackAt && (
                          <div className="flex items-center">
                            <AlertCircle className="h-4 w-4 mr-1" />
                            <span>Chargeback: {new Date(payment.chargebackAt).toLocaleString()}</span>
                          </div>
                        )}
                      </div>

                      {/* Failure Reason */}
                      {payment.failureReason && (
                        <div className="mt-2 p-2 bg-red-50 border border-red-200 rounded text-sm text-red-700">
                          <strong>Failure Reason:</strong> {payment.failureReason}
                        </div>
                      )}
                    </div>

                    {/* Actions */}
                    <div className="flex items-center space-x-2 ml-4">
                      {payment.status === 'failed' && (
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => handleRetryPayment(payment.id)}
                        >
                          <RefreshCw className="h-3 w-3 mr-1" />
                          Retry
                        </Button>
                      )}
                      {payment.status === 'completed' && (
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => handleRefundPayment(payment.id)}
                        >
                          <RotateCcw className="h-3 w-3 mr-1" />
                          Refund
                        </Button>
                      )}
                      {payment.status === 'completed' && (
                        <Button
                          size="sm"
                          variant="outline"
                          onClick={() => handleChargebackPayment(payment.id)}
                        >
                          <AlertCircle className="h-3 w-3 mr-1" />
                          Chargeback
                        </Button>
                      )}
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleEditPayment(payment)}
                      >
                        <Edit className="h-3 w-3 mr-1" />
                        Edit
                      </Button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </CardContent>
      </Card>

      {/* Quick Actions */}
      <Card className="mt-8">
        <CardHeader>
          <CardTitle className="flex items-center">
            <Zap className="h-5 w-5 mr-2" />
            Quick Actions
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <Button className="h-20 flex flex-col items-center justify-center space-y-2">
              <Plus className="h-6 w-6" />
              <span>Process Payment</span>
            </Button>
            <Button variant="outline" className="h-20 flex flex-col items-center justify-center space-y-2">
              <RotateCcw className="h-6 w-6" />
              <span>Process Refund</span>
            </Button>
            <Button variant="outline" className="h-20 flex flex-col items-center justify-center space-y-2">
              <BarChart3 className="h-6 w-6" />
              <span>View Analytics</span>
            </Button>
            <Button variant="outline" className="h-20 flex flex-col items-center justify-center space-y-2">
              <Settings className="h-6 w-6" />
              <span>Gateway Settings</span>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentProcessing;
